import { NickNameModalService } from '@app/feature/main/roles-shared/services/nick-name-modal.service';
import { Router } from '@angular/router';
import { Directive, ElementRef, HostListener, Input, Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ConnectMiniProfileComponent } from '@app/shared/components/connect-mini-profile/connect-mini-profile.component';
import { ProfileMiniService } from '@app/feature/main/roles-shared/services/profile-mini.service';
import { CommentComponent } from '@app/shared/components/comment/comment.component';
import { AuthenticationService } from '@app/shared/services/authentication.service';
declare var $: any;
@Directive({
  selector: '[appDynamicContent]'
})

export class DynamicContentDirective {
  @Output() appScrollToEnd = new EventEmitter();
  @ViewChild(ConnectMiniProfileComponent) connectMiniModal: ConnectMiniProfileComponent;
  // tslint:disable-next-line:max-line-length
  constructor(private el: ElementRef,
    private router:Router,
    private profileMiniService:ProfileMiniService,
    private CommentComponent:CommentComponent,
    private authenticationService: AuthenticationService) { }

  @Input('appDynamicContent') dynamicContent: string;

  @HostListener('click', ['$event']) onClick(e) {
    if (e.target.classList.contains('mention-text')) {
      const link: string = e.target.innerHTML;
      const id: string = e.target.classList[1];
      const role: string = e.target.classList[2];
      event.preventDefault();
      event.stopPropagation();
      // $(".modal-backdrop").hide();
      // $(".modal-open").css('overflow', 'auto');
      // $("#commentModal").modal('hide');
      const loggedInuserRole = this.authenticationService.getFormattedRole();
      if (role === 'tech_analyst') {
        $("#commentModal").modal('hide');
        this.router.navigate(['../../analyst-profile'] , { queryParams: { analystId: id } });
      } else {
        this.CommentComponent.showConnectionMiniModal(id);
      }
    } else if (e.target.classList.contains('hashtag-link')) {
      const link: string = e.target.innerHTML;
      event.preventDefault();
      event.stopPropagation();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/anotation/dynamic-content.directive.ts